import { render, staticRenderFns } from "./reportScreenage.vue?vue&type=template&id=67c5407e&scoped=true"
import script from "./reportScreenage.vue?vue&type=script&lang=js"
export * from "./reportScreenage.vue?vue&type=script&lang=js"
import style0 from "./reportScreenage.vue?vue&type=style&index=0&id=67c5407e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c5407e",
  null
  
)

export default component.exports